// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1toBu","inputWrap":"styles_inputWrap__vC6gE","input":"styles_input__GXtj2"};